<template>
  <input
    @input="$emit('update:modelValue', $event.target.value)"
    :value="modelValue"
    :maxlength="maxlength"
    :class="[
      { 
        disabled: disabled,
        'w-full': stretch, 
        'error': error,
        'valid': valid
      },
      'rounded text-gray-10',
      fontSize,
      padding
    ]"
    type="text"
  />
</template>
<script setup>
import { computed } from "vue"

const props = defineProps({
  modelValue: {
    type: [String, null],
    default: ''
  },
  size: {
    type: String,
    default: "md"
  },
  stretch: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  maxlength: {
    type: Number,
    default: 100
  },
  error: {
    type: Boolean,
    default: false
  },
  valid: {
    type: Boolean,
    default: false
  }
})

defineEmits(["update:modelValue"])

const fontSize = computed(() => {
  return `text-${props.size}`
})

const padding = computed(() => {
  return {
    xs: "p-1 pl-1.5 pr-1.5",
    sm: "p-1.5 pl-2 pr-2",
    md: "p-2 pl-2.5 pr-2.5",
    lg: "p-2 pl-3 pr-3",
    xl: "p-3",
    "2xl": "p-3.5",
    "3xl": "p-4"
  }[props.size]
})
</script>

<style scoped>
input {
  appearance: none;
  border: 1px solid rgba(156, 163, 175);
}

input:focus {
  outline: none;
  border: 1px solid rgba(75, 85, 99);
}

.error {
  border: 2px solid red;
}
.valid {
  border: 2px solid green;
}
</style>
